@let f = field(); @let options = (f?.props?.options | formlySelectOptions: f | async) || []; @let opts =
(resolveValue(f) | transform:showSelected:options:f) ?? []; @let canRemoveOption = canRemove(); @if(!shorten()) {
<mat-chip-set>
  @for(opt of opts; track opt.value) {
  <mat-chip *ngIf="opt.value !== null" (removed)="remove.emit(opt.value)">
    <span class="label">{{ opt.label }}</span>
    <button *ngIf="canRemoveOption" matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
  }
</mat-chip-set>
} @else { @if (showPreview()) {
<div
  class="chip"
  [style.visibility]="opts?.[0]?.value !== null ? 'visible' : 'hidden'"
  (removed)="remove.emit(opts?.[0]?.value)"
>
  <span class="label">{{ opts?.[0]?.label }}</span>
  <mat-icon *ngIf="canRemoveOption">cancel</mat-icon>
</div>
} @else if (opts.length) {
<span class="label">+{{ opts.length }}</span>
} }
